import type { InjectedRouter } from 'js/lib/connectToRouter';

import { enableProgramBuilder } from 'bundles/enterprise-admin-ai-program-builder/utils';
import enterpriseAdminUser from 'bundles/enterprise-admin/enterprise-admin-index';
import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const navigateToNewProgramCreation = (
  router: InjectedRouter,
  thirdPartyOrganizationSlug: string,
  contractId?: string
) => {
  let programCreationLink = `/o/${thirdPartyOrganizationSlug}/program-creation`;
  if (contractId) {
    programCreationLink += `?contractId=${contractId}`;
  }
  router.push(programCreationLink);
};

export const navigateToProgramCreation = (
  thirdPartyOrganizationSlug: string,
  router?: InjectedRouter,
  contractId?: string
) => {
  const isSelfServe = !enterpriseAdminUser.isStandardContractUser();
  const enableProgramBuilderForWES = EnterpriseExperiments.get('enableProgramBuilderForWES');

  if (isSelfServe && enableProgramBuilderForWES) {
    router?.push(`/o/${thirdPartyOrganizationSlug}/program-builder/new-program`);
  } else if (enableProgramBuilder(thirdPartyOrganizationSlug)) {
    router?.push(`/o/${thirdPartyOrganizationSlug}/program-builder/new-program`);
  } else if (router) {
    navigateToNewProgramCreation(router, thirdPartyOrganizationSlug, contractId);
  }
};
